import { useState, useEffect } from 'react'
import { Alert, Table, Spinner  } from 'reactstrap'
import { handleGraphQLErrors, publishEvent, dateTimeStamp } from '../../utils'
import { gql } from '@apollo/client'
import { GET_DATAPUMP_JOBS_QUERY } from '../../graphql.js'
import useInterval from '../CustomHooks/useInterval'
import PubSub from 'pubsub-js'

export const GET_DATAPUMP_JOBS = gql(GET_DATAPUMP_JOBS_QUERY)

export default function DatapumpJobs(props) {
  console.log('DatapumpJobs rendered: ', props)

  const { source } = props
  const [jobList] = useState([])
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [refresh, setRefresh] = useState(0)
  const [increment, setIncrement] = useState(0)

  useInterval(() => setRefresh(refresh + increment), 5000)

  useEffect(() => {
    function handleDatapumpJobSubmittedEvent(msg, data) {
      console.log(`EVENT RECEIVED (DatapumpJobs): ${msg}`, data)
      addJob(data)
      setIncrement(1)
    }
    const subToken = PubSub.subscribe(`${source}_DATAPUMP_JOB_SUBMITTED`, handleDatapumpJobSubmittedEvent)
    return function cleanup() {
      PubSub.unsubscribe(subToken)
    }
  })
  
  useEffect(() => {
    async function fetchItems() {
      console.log('DatapumpJobs.useEffect.fetchItems')
      try {
        const { data, errors } = await window.apolloClient.query({ query: GET_DATAPUMP_JOBS })
        console.log('getDatapumpJobs returned: ', data, errors)
        const newJobList = []
        for (let aJob of jobList) {
          let matchFound = false
          for (let aStatus of data.getDatapumpJobs) {
            if (aStatus.jobName === aJob.jobName) {
              matchFound = true
              aJob.status = aStatus.status
              aJob.owner = aStatus.owner
              aJob.mode = aStatus.mode
              newJobList.push(aJob)
            }
          }
          if (!matchFound) {
            aJob.status = 'FINISHED'
            aJob.finished = dateTimeStamp()
            publishEvent(`${source}_${aJob.operation}_JOB_FINISHED`, aJob, 'DatapumpHistory')
            publishEvent(`${source}_DATAPUMP_JOB_FINISHED`, aJob, 'DatapumpHistory')
          }
        }
        console.log('jobList BEFORE: ', jobList)
        jobList.length = 0
        for (let job of newJobList) {
          jobList.push(job)
        }
        console.log('jobList AFTER: ', jobList)
        if (!data.getDatapumpJobs.length) {
          setIncrement(0)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        console.log('DatapumpJobs.catch: ', err)
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    fetchItems()
  }, [refresh, source, jobList])

  function addJob(job) {
    console.log('DatapumpJobs.addJob: ', job)
    jobList.push(job)
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  }

  const rows = []
  for (let job of jobList) {
    let color = job.status === 'COMPLETING' ? 'warning' : 'success'
    rows.push(
      <tr key={job.jobName}>
        <td>{job.owner}</td>
        <td>{job.jobName}</td>
        <td>{job.operation}</td>
        <td>{job.mode}</td>
        <td>{job.status}</td>
        <td><Spinner size="sm" type="grow" color={color} /></td>
      </tr>
    )
  }

  if (jobList.length) {
    return (
      <div style={{ textAlign: 'center', height: '100%', overflow: 'auto', padding: '10px' }}>
        <div style={{ textAlign: 'center', padding: '10pxs' }}>
          <Table bordered size="sm" style={{ width: 'auto', margin: 'auto' }}>
            <thead>
              <tr><th colSpan={6}>Datapump Jobs</th></tr>
              <tr>
                <th>Owner</th>
                <th>Job Name</th>
                <th>Operation</th>
                <th>Mode</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
  return ''
}
